/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub.hub-element-placeholder.config-panel.title': '元素',
  'company-hub.hub-element-placeholder.extension.lozenge-updated': '已更新',
  'company-hub.hub-element-placeholder.extension.new-lozenge': '新增',
  'company-hub.hub-element-placeholder.extension.sub-heading': '這裡還沒有任何內容可以顯示。想看看可以放哪些內容...',
  'company-hub.hub-element-placeholder.extension.view-all-options': '檢視所有選項',
  'company-hub.hub-element-placeholder.manifest.extension-title': '中心元素預留位置',
};
